import { TableCountProps, Typography } from "@commonlibs";
import clsx from "clsx";
import useTranslate from "ui/locale/hooks/useTranslate";

const TableCount = ({ range, total, className, style }: TableCountProps): JSX.Element => {
    const translate = useTranslate();

    return (
        <Typography variant="body2Light" light className={clsx("table-count", className)} style={style}>
            {translate("showingRofNResults", { lowest: range[0], highest: range[1], total })}
        </Typography>
    );
};

export default TableCount;
